import { cva } from '@/styled-system/css';

export const sliderRootRecipe = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    height: 'Slider.Root.height',
    userSelect: 'none',
    touchAction: 'none',
  },
  variants: {
    snapDragDisabled: {
      true: {},
      false: {},
    },
    disabled: {
      true: {
        opacity: 'disabled',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      snapDragDisabled: false,
      css: {
        cursor: 'grab',
        _active: {
          cursor: 'grabbing',
        },
      },
    },
  ],
});
